import React, { useState, useEffect } from "react"; 
import { useNavigate } from "react-router-dom";
import { api } from "../../services/api";
import Menu from "../../comum/Menu";
import Footer from "../../comum/Footer";
import BarcodeModal from "../Components/BarcodeScanner";
import { Modal, Button } from "react-bootstrap";
import Swal from "sweetalert2";
import ValidadeCard from "../Components/CardValidade";

// Helpers (Mantidos)
const parseCurrencyToNumber = (v) => {
    if (v == null) return 0;
    if (typeof v === "number") return v;
    const s = String(v).replace(/\./g, "").replace(/,/g, ".");
    const n = parseFloat(s);
    return isNaN(n) ? 0 : n;
};

const formatarNumeroParaAPI = (valor) => {
    const numeroFormatado = parseFloat(valor).toFixed(2);
    return numeroFormatado.replace(".", ",");
};

const formatarMoeda = (valor) =>
    new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2,
    }).format(parseCurrencyToNumber(valor));

const formatarData = (data) => {
    if (!data) return "";
    if (data.includes("/")) return data;
    const d = new Date(data);
    const dia = String(d.getDate()).padStart(2, "0");
    const mes = String(d.getMonth() + 1).padStart(2, "0");
    const ano = d.getFullYear();
    return `${dia}/${mes}/${ano}`;
};

const formatarDataParaEnvio = (data) => {
    if (!data) return "";
    const [ano, mes, dia] = data.split("-");
    return `${dia}/${mes}/${ano}`;
};

// Loading modal (Mantido)
function LoadingModal({ show, message }) {
    if (!show) return null;
    return (
        <div className="loading-modal-overlay">
            <div className="loading-modal-content">
                <div
                    className="spinner-border text-primary"
                    role="status"
                    style={{ width: "3rem", height: "3rem" }}
                />
                <div style={{ marginTop: 15, fontSize: 18 }}>{message}</div>
            </div>
            <style>{`
        .loading-modal-overlay {
          position: fixed; top:0; left:0; right:0; bottom:0;
          background: rgba(0,0,0,0.5);
          display:flex; justify-content:center; align-items:center;
          z-index:1050;
        }
        .loading-modal-content {
          background:white; padding:20px 40px; border-radius:8px;
          display:flex; flex-direction:column; align-items:center;
        }
      `}</style>
        </div>
    );
}

// Componente principal
function ValidadeProduto() {
    const [ean, setEan] = useState("");
    const [produto, setProduto] = useState(null);
    const [showScanner, setShowScanner] = useState(false);

    const [validade, setValidade] = useState("");
    const [qtde, setQtde] = useState("");

    const [datas, setDatas] = useState([]);
    const [abertos, setAbertos] = useState({});
    const [itens, setItens] = useState({});

    const [loading, setLoading] = useState(false);
    const [loadingMessage, setLoadingMessage] = useState("");
    const [showModal, setShowModal] = useState(false);

    const [lojaSelecionada, setLojaSelecionada] = useState(null);
    const navigate = useNavigate();
    const chapa = localStorage.getItem("chapa");
    const usuario = chapa;
    const [dentroDoRaio, setDentroDoRaio] = useState(false);

    function calcularDistancia(lat1, lon1, lat2, lon2) {
        const R = 6371;
        const dLat = (lat2 - lat1) * (Math.PI / 180);
        const dLon = (lon2 - lon1) * (Math.PI / 180);
        const a =
            Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(lat1 * (Math.PI / 180)) *
            Math.cos(lat2 * (Math.PI / 180)) *
            Math.sin(dLon / 2) *
            Math.sin(dLon / 2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        return R * c;
    }

    const buscarProduto = async (eanParam = null) => {
        const eanSearch = eanParam ?? ean;
        if (!eanSearch) return;
        if (!lojaSelecionada) {
            Swal.fire("Atenção", "Loja não selecionada. Recarregue a página.", "warning");
            return;
        }
        try {
            setLoading(true);
            setLoadingMessage("Consultando produto...");
            const resp = await api.get(
                `etiqueta?loja=${lojaSelecionada?.cod_emp}&ean=${encodeURIComponent(
                    eanSearch
                )}`
            );
            const data = resp.data;
            if (!data || data.statusvenda !== "A") {
                Swal.fire("Atenção", "Produto inválido ou bloqueado.", "warning");
                return;
            }
            setProduto({ ...data, ean: eanSearch, foto: data.url_foto });
            setShowModal(true);
            setEan("");
        } catch (err) {
            console.error(err);
            Swal.fire("Erro", "Erro ao buscar produto.", "error");
        } finally {
            setLoading(false);
        }
    };

    const carregarItensPorData = async (data) => {
        if (!lojaSelecionada) return;
        try {
            const dataFormatada = data.replaceAll("/", "");
            const resp = await api.get(
                `validade/produto/${lojaSelecionada?.cod_emp}/${dataFormatada}`
            );
            setItens((prev) => ({ ...prev, [data]: resp.data }));
        } catch (err) {
            console.error(err);
        }
    };

    const salvarValidade = async () => {
        if (!produto || !validade || !qtde) {
            Swal.fire("Atenção", "Preencha validade e quantidade.", "warning");
            return;
        }
        if (!lojaSelecionada) {
            Swal.fire("Erro", "Loja não selecionada. Impossível salvar.", "error");
            return;
        }

        try {
            setLoading(true);
            setLoadingMessage("Salvando validade...");
            const validadeFormatada = formatarDataParaEnvio(validade);
            const validadeParaUI = formatarData(validade); 

            const body = {
                loja: lojaSelecionada?.cod_emp,
                codigo: produto.seqproduto,
                ean: produto.ean,
                descricao: produto.desccompleta,
                validade: validadeFormatada,
                qtde: qtde,
                estoque: produto.estqloja ?? 0,
                matricula: usuario,
                preco: formatarNumeroParaAPI(produto.preco),
                custo: produto.precocusto ?? 0,
            };

            await api.post("validade", body);
            Swal.fire("Sucesso", "Validade salva com sucesso.", "success");
            setShowModal(false);
            setValidade("");
            setQtde("");

            await carregarDatas();
            await carregarItensPorData(validadeParaUI);
        } catch (err) {
            console.error(err);
            Swal.fire("Erro", "Erro ao salvar validade.", "error");
        } finally {
            setLoading(false);
        }
    };

    const carregarDatas = async () => {
        if (!lojaSelecionada) return;
        try {
            setLoading(true);
            setLoadingMessage("Carregando datas...");
            const resp = await api.get(`validade/${lojaSelecionada?.cod_emp}`);
            setDatas(resp.data || []);
        } catch (err) {
            console.error(err);
            setDatas([]);
        } finally {
            setLoading(false);
        }
    };

    const toggleData = async (data) => {
        const novoAberto = !abertos[data];
        setAbertos((prev) => ({ ...prev, [data]: novoAberto }));

        if (novoAberto) {
            await carregarItensPorData(data);
        }
    };

    // NOVA FUNÇÃO PARA TRATAR O FALLBACK DA LOJA PADRÃO
    const carregarLojaPadrao = (lojas) => {
        // lojaprincipal armazena apenas o número da loja (ex: "1", "2")
        const codLojaPrincipal = localStorage.getItem("lojaprincipal");
        
        if (codLojaPrincipal && lojas && lojas.length > 0) {
            // Encontra a loja na lista que corresponde ao código principal
            const lojaPadrao = lojas.find(loja => 
                String(loja.cod_emp) === codLojaPrincipal
            );

            if (lojaPadrao) {
                setLojaSelecionada(lojaPadrao);
                setDentroDoRaio(true); // Usando como loja de trabalho
                Swal.fire(
                    "Atenção",
                    `Não foi possível confirmar sua localização (GPS desabilitado ou fora do raio). Utilizando loja principal definida: ${lojaPadrao.razao}.`,
                    "warning"
                );
                return true; // Loja padrão carregada com sucesso
            }
        }
        
        // Se falhar em todos os casos
        Swal.fire(
            "Erro",
            "Não foi possível obter sua localização nem carregar a loja padrão. Tente fazer login novamente.",
            "error"
        );
        setDentroDoRaio(false);
        return false; // Loja padrão não carregada
    };

    // NOVA FUNÇÃO PARA CENTRALIZAR A LÓGICA DE LOCALIZAÇÃO E FALLBACK
    const determinarLoja = async () => {
        // 1. Carregar a lista de todas as lojas
        let lojas = [];
        try {
            const resp = await api.get("lojas/localizacao");
            lojas = resp.data || [];
            if (lojas.length === 0) {
                 Swal.fire("Erro", "Nenhuma loja foi encontrada na base de dados.", "error");
                 carregarLojaPadrao(lojas); // Tenta carregar mesmo com lista vazia (improvável, mas seguro)
                 return;
            }
        } catch (err) {
            console.error("Erro ao buscar lojas:", err);
            // Em caso de erro na API, tenta carregar a loja padrão com lista vazia
            carregarLojaPadrao(lojas); 
            return;
        }

        // 2. Tentar obter a localização atual do usuário
        navigator.geolocation.getCurrentPosition(
            (pos) => {
                const { latitude, longitude } = pos.coords;
                
                // 3. Verificar se está no raio de alguma loja
                const lojaProxima = lojas.find((loja) => {
                    const distKm = calcularDistancia(
                        latitude,
                        longitude,
                        parseFloat(loja.latitude),
                        parseFloat(loja.longitude)
                    );
                    const distMetros = distKm * 1000;
                    return distMetros <= parseFloat(loja.distancia || 0);
                });

                if (lojaProxima) {
                    setLojaSelecionada(lojaProxima);
                    setDentroDoRaio(true);
                } else {
                    Swal.fire(
                        "Atenção",
                        "Você não está dentro do raio de uma loja.",
                        "warning"
                    );
                    // 4. Se não estiver no raio, tenta fallback para loja padrão
                    carregarLojaPadrao(lojas);
                }
            },
            (err) => {
                console.error("Erro ao obter localização (GPS):", err);
                // 5. Se o GPS falhar, tenta fallback para loja padrão
                carregarLojaPadrao(lojas);
            }
        );
    };

    useEffect(() => {
        if (!chapa) {
            navigate("/arbor/login");
            return;
        }
        
        determinarLoja();

    }, [chapa, navigate]);

    useEffect(() => {
        if (lojaSelecionada) carregarDatas();
    }, [lojaSelecionada]);

    return (
        <div className="d-flex flex-column min-vh-100">
            <Menu modulo="ARBOR" />
            <div className="container-fluid flex-grow-1 conteudo-principal">
                <div className="row justify-content-center">
                    <div className="col-lg-6">
                        <div className="mb-3">
                            <label>Loja</label>
                            <input
                                className="form-control"
                                value={lojaSelecionada?.razao || "Carregando..."}
                                readOnly
                            />
                        </div>

                        <div className="mb-3">
                            <label>Código de barras</label>
                            <div className="input-group">
                                <input
                                    value={ean}
                                    onChange={(e) => setEan(e.target.value)}
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter") buscarProduto();
                                    }}
                                    maxLength={30}
                                    type="text"
                                    className="form-control"
                                    placeholder="Digite ou escaneie"
                                    disabled={!lojaSelecionada}
                                />
                                <button
                                    className="btn btn-primary"
                                    type="button"
                                    onClick={() => buscarProduto()}
                                    disabled={!ean || !lojaSelecionada}
                                >
                                    <i className="fas fa-search"></i>
                                </button>
                                <button
                                    className="btn btn-secondary"
                                    type="button"
                                    onClick={() => setShowScanner(true)}
                                    disabled={!lojaSelecionada}
                                >
                                    <i className="fas fa-camera"></i>
                                </button>
                            </div>
                        </div>

                        <h4 className="mt-4">Próximos Vencimentos</h4>
                        {lojaSelecionada ? (
                            datas.map((d, idx) => (
                                <div key={idx} className="mb-2 border rounded">
                                    <div
                                        className="d-flex justify-content-between align-items-center p-2 bg-light"
                                        style={{ cursor: "pointer" }}
                                        onClick={() => toggleData(d.data)}
                                    >
                                        <span>
                                            {d.data} - {d.itens} itens
                                        </span>
                                        <span>{abertos[d.data] ? "▲" : "▼"}</span>
                                    </div>
                                    {abertos[d.data] && (
                                        <div className="p-2">
                                            <div className="row">
                                                {itens[d.data] && itens[d.data].length > 0 ? (
                                                    itens[d.data].map((prod) => (
                                                        <ValidadeCard
                                                            key={prod.seq}
                                                            val={prod}
                                                        />
                                                    ))
                                                ) : (
                                                    <p>Nenhum item encontrado</p>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            ))
                        ) : (
                            <p>Carregando dados da loja...</p>
                        )}
                    </div>
                </div>
            </div>

            <Modal show={showModal} onHide={() => setShowModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Salvar Validade</Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-center">
                    {produto && (
                        <>
                            <img
                                src={`https://cdn-cosmos.bluesoft.com.br/products/${produto.ean}`}
                                alt={produto.desccompleta}
                                className="img-fluid mb-2"
                                style={{ maxHeight: "150px", objectFit: "contain" }}
                                onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src =
                                        "https://multilit.com.br/wp-content/uploads/2020/03/Produto-sem-foto.png";
                                }}
                            />
                            <h5>{produto.desccompleta}</h5>
                            <p>EAN: {produto.ean}</p>
                            <p>Preço: {formatarMoeda(produto.preco)}</p>
                            <div className="mb-2">
                                <label>Data de Validade</label>
                                <input
                                    type="date"
                                    className="form-control"
                                    value={validade}
                                    onChange={(e) => setValidade(e.target.value)}
                                />
                            </div>
                            <div className="mb-2">
                                <label>Quantidade</label>
                                <input
                                    type="number"
                                    className="form-control"
                                    value={qtde}
                                    onChange={(e) => setQtde(e.target.value)}
                                />
                            </div>
                        </>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="success" onClick={salvarValidade} className="w-100" disabled={!lojaSelecionada}>
                        Salvar Validade
                    </Button>
                </Modal.Footer>
            </Modal>

            <BarcodeModal
                show={showScanner}
                onClose={() => setShowScanner(false)}
                onScanSuccess={(codigo) => {
                    setEan(codigo);
                    setShowScanner(false);
                    buscarProduto(codigo);
                }}
            />

            <LoadingModal show={loading} message={loadingMessage} />
            <Footer />
        </div>
    );
}

export default ValidadeProduto;